import * as z from 'zod';

export const genderSchema = z.union([
  z.literal('male'),
  z.literal('female'),
  z.literal('none')
]);
